import { useConfigStore } from '../../Stores/Config';
import { useFormStore } from '../../Stores/Form';
import CommunicationManager from '../../Helper/CommunicationManager';
import { ReactComponent as Camera } from '../../Assets/Camera.svg';
import { ReactComponent as XIcon } from '../../Assets/x-mark.svg';
import { ReactComponent as Screenshot } from '../../Assets/Screenshot.svg';
import { activateOnKey } from "../../Helper/a11y";
import "./CaptureFormItem.scss";

function CaptureFormItem({ formItem }: { formItem: any }) {
    const configStore = useConfigStore();
    const formStore = useFormStore();
    const formData = formStore.formData;
    const fieldFormData = formData[formItem.name];
    const videoCaptureAvailable = typeof navigator.mediaDevices !== "undefined" && typeof navigator.mediaDevices.getDisplayMedia !== "undefined";

    const showMarkerEditor = (type: string) => {
        CommunicationManager.getInstance().sendMessage({
            name: "start-screen-drawing",
            data: type
        });
    }

    const removeCapture = () => {
        formStore.setFormData("capture", {
            value: undefined,
            dirty: false
        });
        CommunicationManager.getInstance().sendMessage({
            name: "cleanup-drawings"
        });
    }

    if (fieldFormData && fieldFormData.value) {
        return (<div className='capture-buttons'>
            <div className='capture-added-button'>
                {fieldFormData.value === "screenshot" ? <Screenshot /> : <Camera />}
                <span>{configStore.translateText(fieldFormData.value === "screenshot" ? "screenshot" : "screenRecording")}</span>
                <div className='capture-added-button-remove' role="button" tabIndex={0} aria-label="Remove capture" onClick={removeCapture} onKeyDown={activateOnKey(removeCapture)}>
                    <XIcon /></div>
            </div>
        </div>);
    }

    return (
        <div className='capture-buttons'>
            {formItem.enableScreenshot &&
                <div className='capture-button capture-button--screenshot tooltip' role="button" tabIndex={0} onClick={() => {
                    showMarkerEditor("screenshot");
                }} onKeyDown={activateOnKey(() => {
                    showMarkerEditor("screenshot");
                })}>
                    <Screenshot />
                    <span>{formItem.screenshotTitle}</span>
                    <div className="top">
                        <p>{formItem.screenshotTitle}</p>
                        <i></i>
                    </div>
                </div>}
            {formItem.enableCapture && videoCaptureAvailable &&
                <div className='capture-button tooltip' role="button" tabIndex={0} onClick={() => {
                    showMarkerEditor("capture");
                }} onKeyDown={activateOnKey(() => {
                    showMarkerEditor("capture");
                })}>
                    <Camera />
                    <span>{formItem.captureTitle}</span>
                    <div className="top">
                        <p>{formItem.captureTitle}</p>
                        <i></i>
                    </div>
                </div>}
        </div>
    );
}

export default CaptureFormItem;
